module.exports = __webpack_public_path__ + "static/img/Trent-Sainsbury.0fb03cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Trent-Sainsbury.jpg
// module id = c8BV
// module chunks = 0